import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth, arrowWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLACK } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const a = (state, workState) => (
	<g id="Track-16D-black" transform="translate(2313.000000, 432.000000)">
		<g id="line" stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
			 strokeLinecap="round" strokeWidth={tracksWidth}>
			<path
				d="M10.6216127,62.892787 L13.5765748,83.6802473 C15.5765801,97.7498119 22.3492186,110.705277 32.7606311,120.377669 L45.5639475,132.272183 C51.19575,137.50423 57.4120537,142.069452 64.0897034,145.877406 L98.5,165.5 L98.5,165.5"
				id="Line"/>
			<polyline id="arrow" strokeWidth={arrowWidth} strokeLinejoin="round"
								transform="translate(8.945515, 50.273329) rotate(-98.000000) translate(-8.945515, -50.273329) "
								points="12.9455146 58.273329 4.94551463 50.273329 12.9455146 42.273329"/>
			<line x1="3" y1="0" x2="9.31640248" y2="53.3456745" id="Line"/>
		</g>
	</g>
);

const Track16DBlack = ({ state, workState, onLabelClick }) => (
	<g id="Track16DBlack" transform="translate(2311.000000, 431.000000)" className="track">
		<g id="line" stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
			 strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path
				d="M10.6216127,62.892787 L13.5765748,83.6802473 C15.5765801,97.7498119 22.3492186,110.705277 32.7606311,120.377669 L45.5639475,132.272183 C51.19575,137.50423 57.4120537,142.069452 64.0897034,145.877406 L98.5,165.5 L98.5,165.5"
				strokeLinecap="round"
			/>

			<TrackArrow
				transform="translate(8.945515, 50.273329) rotate(-98.000000) translate(-8.945515, -50.273329) "
				points="12.9455146 58.273329 4.94551463 50.273329 12.9455146 42.273329"/>

			<line x1="3" y1="0" x2="9.31640248" y2="53.3456745" strokeLinecap="round"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track16DBlack')}
			coords="1.902907, 91.809092"
			text="16D"
			textCoordsX="6.31835938"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
		/>
	</g>
);

Track16DBlack.propTypes = trackPropTypes;

export default Track16DBlack;
